import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { withRouter } from 'react-router-dom';
import "./css/materialize.css";
import "./css/style.css";
import axios from 'axios';
import { API_URL } from '../QRQinectAPI';

class EnterEmail extends Component {
    constructor(props) {
        super(props);
        this.state = props.location.state;
        this.state.name = '';
        this.state.email = '';

        this.continue = this.continue.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.updateState = props.updateState;
    }
    componentDidMount() {
        let scannedQRCode = matchPath(window.location.pathname, {
            path: '/scan/:id',
            exact: false
        });
        let qrGUID = scannedQRCode ? scannedQRCode.params.id : null;
        this.setState({ QRCode: qrGUID });
    }
    continue = () => {
        if (this.state.invalidEmail || this.state.invalidName ||
            this.state.email === '' || this.state.name === '') {
            return;
        }
        axios.get(API_URL + 'api/v1/registerBuyer', {
            params: {
                type: "Email",
                id: 0,
                img: "",
                QRCode: this.state.QRCode,
                name: this.state.name,
                email: this.state.email,
                newsletter: this.state.newsletter,
                redirect: window.location.href.replace(/[^/]*$/, 'video')
            }
        })
            .then((response) => {
                //update the Index state with the Buyer
                this.updateState({ Buyer: response.data });
                if (response.data.ID === 0) {
                    this.setState({ error: "An unknown error occurred, please try again." });
                    return;
                }
                // if the email exists and is valid, redirect to video selection page
                if (response.data.Validated) {
                    this.props.history.push({
                        pathname: 'video',
                        state: { Buyer: response.data }
                    });
                } else {
                    // if email requires validation, redirect to the verifaction page
                    this.props.history.push({
                        pathname: 'verification',
                        state: { Email: response.data.Email }
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ error: error.response });
            });
    }
    handleNameChange(event) {
        let name = event.target.value;
        this.setState({ name: event.target.value });
        this.setState({ invalidName: !name });
    }
    handleEmailChange(event) {
        let email = event.target.value;
        let valid;
        this.setState({ email: email });
        // check if email is 'valid'
        if (/^.+@.+\..+$/.test(email)) {
            valid = true;
        } else {
            valid = false;
        }
        this.setState({ invalidEmail: !valid });
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>
                                {/* <img src={require("./img/logo_gray_green.png")} width={"100%"}/> */}
                                <p>Please enter your information below</p>
                                <form action="#">
                                    <div className="input-field">
                                        <input id="name" type="text" className="validate" onChange={event => this.handleNameChange(event)} />
                                        <label htmlFor="name">Name</label>
                                    </div>
                                    <div style={{ color: 'red' }}>{this.state.invalidName ? 'Please enter a name' : ''}</div>
                                    <div className="input-field">
                                        <input id="email" type="email" className="validate" onChange={event => this.handleEmailChange(event)} />
                                        <label htmlFor="email">Email</label>
                                    </div>
                                    <div style={{ color: 'red' }}>{this.state.invalidEmail ? 'Please enter a valid email address' : ''}</div>
                                </form>
                            </div>
                            <div>{this.state.error ? this.state.error : ''}</div>
                            <a className="button" onClick={() => this.continue()}>NEXT</a>
                            {/* <Link to='verfification' className="button">NEXT</Link> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EnterEmail);



// WEBPACK FOOTER //
// ./src/components/EnterEmail.js